import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Copy from '@nib-components/copy';
import Heading from '@nib-components/heading';
import {Box, Columns, Column, Stack} from '@nib/layout';
import {colorWhite} from '@nib-components/theme';
import {AlertType, AlertProps, validTypeValues, typeValues} from '../types';
import {pickColor, renderIcon} from '../utils';

interface IconWrapperProps {
  readonly type: typeValues;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Wrapper = styled(({fullWidth, type, variation, ...rest}) => <div {...rest} />)<AlertProps>`
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  background-color: ${colorWhite};
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const IconWrapper = styled(({type, ...rest}) => <div {...rest} />)<IconWrapperProps>`
  display: flex;
  background-color: ${props => pickColor(props.type)};
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const BorderedBox = styled(({type, isSoft, ...rest}) => <Box padding={3} {...rest} />)`
  width: 100%;
  border-width: 0.25rem;
  border-style: solid;
  border-left: 0;
  border-color: ${props => pickColor(props.type)};
`;

const LoudAlert: React.FC<AlertType> = props => {
  const {title, children, type, fullWidth = false, ...otherProps} = props;

  return (
    <Wrapper fullWidth={fullWidth} type={type} {...otherProps}>
      <Columns align="center">
        <Column flex width="content">
          <IconWrapper type={type}>
            <Box padding={3}>{renderIcon(type, false)}</Box>
          </IconWrapper>
        </Column>
        <Column flex>
          <BorderedBox type={type} display="flex" alignItems="center">
            <Stack space={3}>
              {title && <Heading size={4}>{title}</Heading>}
              {children && (
                <Copy measure={false} component="div">
                  {children}
                </Copy>
              )}
            </Stack>
          </BorderedBox>
        </Column>
      </Columns>
    </Wrapper>
  );
};

LoudAlert.displayName = 'LoudAlert';

LoudAlert.propTypes = {
  type: PropTypes.oneOf(validTypeValues).isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
  fullWidth: PropTypes.bool
};

export default LoudAlert;
